export const TERMS_AND_CONDITIONS = 'https://www.gsc.com.my/terms-and-conditions';
export const PRIVACY_POLICY = 'https://www.gsc.com.my/privacy-policy';
export const LOCK_SEAT_DURATION_IN_SECONDS = 480;
